"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseAPIService_1 = require("./BaseAPIService");
class NumberPoolService extends BaseAPIService_1.default {
    constructor(baseURL, token) {
        super(baseURL, 'pool', token);
    }
    assign(accountId, poolNumber) {
        return super.post(accountId, poolNumber);
    }
}
exports.default = NumberPoolService;
